import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class SalaryTypeService {
   async getSalaryTypes() {
      return await http.get('/salary-types', cacheFirstConfig).then((response: any) => {
         return response.data.data;
      });
   }
}
